import { Ref, ref } from 'vue';
import { Client } from 'app-core';

const updatedClient: Ref<Client | undefined> = ref()

export function useClient() {
  return {
    updatedClient
  }
}
